import type { FeatureFlagSwitcherConfig } from './types';

/**
 * Internal preset configs. Use string IDs in Example, e.g. featureFlagSwitchers={['labelling']}.
 */
const LABELLING_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-lozenge-tag-badge-visual-uplifts',
	label: 'New labelling',
	defaultValue: true,
};

const MOTION_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_UPLIFT_MODAL_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift-modal',
	label: 'Motion',
	defaultValue: true,
};

const FEATURE_FLAG_SWITCHER_PRESETS: Record<string, FeatureFlagSwitcherConfig> = {
	labelling: LABELLING_SWITCHER_CONFIG,
	motion: MOTION_SWITCHER_CONFIG,
	motionModal: MOTION_UPLIFT_MODAL_SWITCHER_CONFIG
};

/**
 * Resolves string IDs to feature flag switcher configs. Unknown IDs are ignored.
 */
export function resolveFeatureFlagSwitchers(ids: string[]): FeatureFlagSwitcherConfig[] {
	return ids
		.map((id) => FEATURE_FLAG_SWITCHER_PRESETS[id])
		.filter((config): config is FeatureFlagSwitcherConfig => config != null);
}
